import React from 'react';

import './plan-title.css';

export const PlanTitle: React.FunctionComponent = ({ children }) => (
  <h2 className="plan-title">{children}</h2>
);
